"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uuid = require("uuid");
var _batchPromises = _interopRequireDefault(require("batch-promises"));
var _PersistentStore2 = _interopRequireDefault(require("./PersistentStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } /*
 * MIT License
 *
 * Copyright (c) 2022 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var _queryPromises = /*#__PURE__*/new WeakMap();
var _unsubPromises = /*#__PURE__*/new WeakMap();
var _getUniqueSubs = /*#__PURE__*/new WeakMap();
var _propagateChange = /*#__PURE__*/new WeakMap();
var _appendIfNotExistent = /*#__PURE__*/new WeakMap();
var _subscribeToObjects = /*#__PURE__*/new WeakMap();
var _ObserverStore_brand = /*#__PURE__*/new WeakSet();
var ObserverStore = /*#__PURE__*/function (_PersistentStore) {
  function ObserverStore(options) {
    var _this;
    _classCallCheck(this, ObserverStore);
    _this = _callSuper(this, ObserverStore, [options]);
    _classPrivateMethodInitSpec(_this, _ObserverStore_brand);
    _classPrivateFieldInitSpec(_this, _queryPromises, []);
    _classPrivateFieldInitSpec(_this, _unsubPromises, []);
    _defineProperty(_this, "multipleSubscribe", function (subscriptions, callback) {
      var dataPayload = {};
      var subKey = (0, _uuid.v4)();
      var areAllDone = function areAllDone() {
        return subscriptions.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            name = _ref2[0];
          return name;
        }).every(function (name) {
          return dataPayload[name] !== undefined;
        });
      };
      Promise.all(subscriptions.map(function (sub) {
        var _sub = _slicedToArray(sub, 2),
          name = _sub[0],
          _sub$ = _sub[1],
          filterFunction = _sub$ === void 0 ? null : _sub$;
        var wrappedCallback = function wrappedCallback(data) {
          dataPayload[name] = data;
          return areAllDone() && callback(dataPayload);
        };
        return _this.subscribe(name, wrappedCallback, filterFunction);
      })).then(function (subKeys) {
        _this._multipleSubscribed[subKey] = subKeys;
        return subKey;
      });
      return subKey;
    });
    _defineProperty(_this, "subscribe", function (type, callback, filterFunction) {
      var _this$_subscribed, _this$_subscribed$typ;
      var subKey = (0, _uuid.v4)();
      (_this$_subscribed$typ = (_this$_subscribed = _this._subscribed)[type]) !== null && _this$_subscribed$typ !== void 0 ? _this$_subscribed$typ : _this$_subscribed[type] = {};
      var prom = _this.find(type, filterFunction).then(function (data) {
        _classPrivateFieldGet(_subscribeToObjects, _this).call(_this, type, data, {
          callback: callback,
          filterFunction: filterFunction,
          subKey: subKey
        });
        callback(data);
      });
      _classPrivateFieldGet(_queryPromises, _this).push(prom);
      return subKey;
    });
    _defineProperty(_this, "unsubscribe", function (key) {
      _classPrivateFieldSet(_unsubPromises, _this, (_classPrivateFieldGet(_queryPromises, _this).length ? Promise.all(_classPrivateFieldGet(_queryPromises, _this)) : Promise.resolve()).then(function () {
        if (_this._multipleSubscribed[key]) {
          var _iterator = _createForOfIteratorHelper(_this._multipleSubscribed[key]),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var sub = _step.value;
              _this.unsubscribe(sub);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          delete _this._multipleSubscribed[key];
        } else {
          for (var type in _this._subscribed) {
            for (var id in _this._subscribed[type]) {
              _this._subscribed[type][id] = _this._subscribed[type][id].filter(function (i) {
                return i.subKey !== key;
              });
              if (_this._subscribed[type]["*"]) {
                _this._subscribed[type]["*"] = _this._subscribed[type]["*"].filter(function (i) {
                  return i.subKey !== key;
                });
              }
              if (_this._subscribed[type][id].length === 0) {
                delete _this._subscribed[type][id];
              }
            }
          }
        }
      }));
    });
    _classPrivateFieldInitSpec(_this, _getUniqueSubs, function (objects, type) {
      var out = {};
      var _iterator2 = _createForOfIteratorHelper(objects),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var object = _step2.value;
          var objectId = object.getId();
          var typeChannel = _this._subscribed[type] || {};
          var subscribedToObject = typeChannel[objectId] || [];
          var _iterator3 = _createForOfIteratorHelper(subscribedToObject),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _sub$subKey, _out$_sub$subKey;
              var sub = _step3.value;
              (_out$_sub$subKey = out[_sub$subKey = sub.subKey]) !== null && _out$_sub$subKey !== void 0 ? _out$_sub$subKey : out[_sub$subKey] = sub;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return Object.values(out);
    });
    _classPrivateFieldInitSpec(_this, _propagateChange, function () {
      var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (_classPrivateFieldGet(_unsubPromises, _this).length ? Promise.all(_classPrivateFieldGet(_unsubPromises, _this)) : Promise.resolve()).then(function () {
        if (objects.length) {
          var _objects$;
          var type = objects === null || objects === void 0 || (_objects$ = objects[0]) === null || _objects$ === void 0 || (_objects$ = _objects$.getModel()) === null || _objects$ === void 0 ? void 0 : _objects$.getType();
          if (type) {
            var uniqueSubs = _classPrivateFieldGet(_getUniqueSubs, _this).call(_this, objects, type);
            return (0, _batchPromises["default"])(10, uniqueSubs, function (_ref3) {
              var callback = _ref3.callback,
                filterFunction = _ref3.filterFunction;
              return _this.find(type, filterFunction).then(callback);
            });
          } else {
            console.log("Malformed update list", objects);
          }
        }
        return objects;
      });
    });
    _classPrivateFieldInitSpec(_this, _appendIfNotExistent, function (arr, item) {
      if (Object.values(arr).filter(function (_ref4) {
        var subKey = _ref4.subKey;
        return item.subKey === subKey;
      }).length === 0) {
        arr.push(item);
      }
    });
    _classPrivateFieldInitSpec(_this, _subscribeToObjects, function (type, objectsToSubscribe, item) {
      var _this$_subscribed$typ2, _, _this$_subscribed$typ3;
      var _iterator4 = _createForOfIteratorHelper(objectsToSubscribe),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _this$_subscribed$typ4, _this$_subscribed$typ5;
          var object = _step4.value;
          var id = object.getId();
          (_this$_subscribed$typ5 = (_this$_subscribed$typ4 = _this._subscribed[type])[id]) !== null && _this$_subscribed$typ5 !== void 0 ? _this$_subscribed$typ5 : _this$_subscribed$typ4[id] = [];
          _classPrivateFieldGet(_appendIfNotExistent, _this).call(_this, _this._subscribed[type][id], item);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      (_this$_subscribed$typ3 = (_this$_subscribed$typ2 = _this._subscribed[type])[_ = "*"]) !== null && _this$_subscribed$typ3 !== void 0 ? _this$_subscribed$typ3 : _this$_subscribed$typ2[_] = [];
      _classPrivateFieldGet(_appendIfNotExistent, _this).call(_this, _this._subscribed[type]["*"], item);
    });
    _defineProperty(_this, "reset", function (type) {
      return _this._refresh(type, true);
    });
    _defineProperty(_this, "refresh", function (type) {
      return _this._refresh(type, false);
    });
    _defineProperty(_this, "_refresh", function (type, force) {
      var refreshByType = function refreshByType(type) {
        _this.pubSub.publish("refresh", {
          status: "start",
          model: type
        });
        return _this.refreshObjectByType(type, force).then(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 3),
            inserted = _ref6[0],
            updated = _ref6[1],
            deleted = _ref6[2];
          var item = _this.models[type];
          return Promise.all([_assertClassBrand(_ObserverStore_brand, _this, _propagateInsertChange).call(_this, type, inserted), _classPrivateFieldGet(_propagateChange, _this).call(_this, updated), _classPrivateFieldGet(_propagateChange, _this).call(_this, deleted)]).then(function () {
            _this.pubSub.publish("refresh", {
              status: "end",
              model: type
            });
            return item.promise;
          });
        });
      };
      if (type) {
        return refreshByType(type);
      } else {
        return Promise.all(Object.keys(_this.models).map(refreshByType));
      }
    });
    _this._subscribed = {};
    _this._multipleSubscribed = {};
    if (options.autoRefresh && typeof options.autoRefresh === "number") {
      setInterval(_this.refresh, options.autoRefresh);
    }
    return _this;
  }
  _inherits(ObserverStore, _PersistentStore);
  return _createClass(ObserverStore, [{
    key: "update",
    value: function update(objects, skipSave) {
      var _objects$filter,
        _this2 = this;
      if (objects !== null && objects !== void 0 && (_objects$filter = objects.filter(function (i) {
        return !!i;
      })) !== null && _objects$filter !== void 0 && _objects$filter.length) {
        if (!skipSave) {
          _classPrivateFieldGet(_propagateChange, this).call(this, objects);
        }
        return _superPropGet(ObserverStore, "update", this, 3)([objects, skipSave]).then(function (data) {
          return _classPrivateFieldGet(_propagateChange, _this2).call(_this2, data);
        });
      }
    }
  }, {
    key: "insert",
    value: function insert(type, objects) {
      var _this3 = this;
      objects = Array.isArray(objects) ? objects : [objects];
      return _superPropGet(ObserverStore, "insert", this, 3)([type, objects]).then(function (objects) {
        _assertClassBrand(_ObserverStore_brand, _this3, _propagateInsertChange).call(_this3, type, objects);
        return objects;
      });
    }
  }, {
    key: "mock",
    value: function mock(type, objects) {
      var _this4 = this;
      objects = Array.isArray(objects) ? objects : [objects];
      return _superPropGet(ObserverStore, "mock", this, 3)([type, objects]).then(function (objects) {
        _assertClassBrand(_ObserverStore_brand, _this4, _propagateInsertChange).call(_this4, type, objects);
        return objects;
      });
    }
  }, {
    key: "delete",
    value: function _delete(typeOrObjects, filterFunction) {
      return _superPropGet(ObserverStore, "delete", this, 3)([typeOrObjects, filterFunction]).then(_classPrivateFieldGet(_propagateChange, this));
    }
  }]);
}(_PersistentStore2["default"]);
function _propagateInsertChange(type, newObjects) {
  var _this5 = this;
  return (_classPrivateFieldGet(_unsubPromises, this).length ? Promise.all(_classPrivateFieldGet(_unsubPromises, this)) : Promise.resolve()).then(function () {
    if (_this5._subscribed[type]) {
      var uniqueSubs = {};
      var objects = Object.values(_this5._subscribed[type]);
      for (var _i = 0, _objects = objects; _i < _objects.length; _i++) {
        var object = _objects[_i];
        var _iterator5 = _createForOfIteratorHelper(object),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var sub = _step5.value;
            if (!uniqueSubs[sub.subKey]) {
              uniqueSubs[sub.subKey] = sub;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      var possibleSubs = Object.values(uniqueSubs);
      return (0, _batchPromises["default"])(10, possibleSubs, function (_ref7) {
        var callback = _ref7.callback,
          filterFunction = _ref7.filterFunction,
          subKey = _ref7.subKey;
        var objectsToSubscribe = filterFunction ? newObjects.filter(filterFunction) : newObjects;
        if (objectsToSubscribe.length) {
          // Check if the new objects matter

          return _this5.find(type, filterFunction).then(function (data) {
            _classPrivateFieldGet(_subscribeToObjects, _this5).call(_this5, type, objectsToSubscribe, {
              callback: callback,
              filterFunction: filterFunction,
              subKey: subKey
            });
            return data;
          }).then(callback);
        }
      });
    }
  });
}
var _default = exports["default"] = ObserverStore;